import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppConstants } from 'src/app-constants';
import { BaseComponent } from './components/base.component';
import { TokenRequestSM } from './service-models/token/token-request-s-m';
import { CommonService } from './services/common.service';
import { LogHandlerService } from './services/log-handler.service';
import { LoginService } from './services/login.service';
import { LoginViewModel } from './view-models/login.viewmodel';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

})
export class AppComponent extends BaseComponent<LoginViewModel> implements OnInit {
  
  showToast: boolean=false;
  menu: boolean = false;
  title = 'Security Related';
  
 
  constructor(private router:Router,commonService: CommonService, logService: LogHandlerService) {
    super(commonService, logService);
    
  }
 

  ngOnInit() {
    this.viewModel = new LoginViewModel();
    this.viewModel.tokenRequest = new TokenRequestSM()

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/login' || event.url === '/sign-up' || event.url === '/forgot-password') {
          this.menu = false;
        } else {
          this.menu = true;
        }
      }
    });
  }


  

    // async presentAlert() {
    //   let x = await this._commonService.presentConfirmAlert({
    //     title: 'Test',
    //     subTitle: 'Test Sub',
    //     message: 'Test Message',
    //     showModal: true
    //   })
    //    this._exceptionHandler.logObject(x);
    //   // console.log(x);
    // }
  
  

  }

